<template>
	<div>
		<span class="m-0" id="cart"></span>

		<!-- EMPTY CART -->
		<div v-if="store.cart.length == 0" class="bg-white text-center mt-8 mb-2 ">
      <img src="../../../../assets/img/icon/namaste.png" width="310">
      <p class="pt-3 heading-4 text-22 mb-2">{{$t('ticket-cart.empty-cart.title')}}</p>
      <p class="body-2 mb-4 w-75 mx-auto">{{$t('ticket-cart.empty-cart.message')}}</p>
      <div class="w-100 text-center">
        <button class="btn bg-green text-14 body-3-1 text-white px-3 text-truncate" @click="goMerchantList()">{{$t('ticket-cart.empty-cart.button')}}</button>
      </div>
    </div>

    <!-- CART -->
    <div v-else class="chat-container w-100 position-relative">
      <div v-if="is_load" class="w-100 py-5 text-center">
        <loader />
      </div>
      <template v-else>
        <ErrorMessage v-if="error != ''" :message="error" />
        <template v-else>
        	<!-- NAV -->
					<wrapper-mobile-view>
						<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
							<div class="w-100">
								<div class="row">
									<div class="col-1 align-self-center">
										<router-link v-if="cart_step == 1" :to="'/'+getMerchant.code+'/concierge/experience/'+store.merchant.id+'/list'" class="d-inline-grid">
	                    <img src="../../../../assets/img/icon/back.png" class="mt-1" width="20">
	                  </router-link>
                    <div class="w-100 cursor-pointer" v-else @click="changeCartStep(1)">
                      <img src="../../../../assets/img/icon/back.png" class="mt-1" width="20">
                    </div>
									</div>
									<div class="col-10 align-self-center">
										<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.order-summary')}}</p>
									</div>
								</div>
							</div>
						</div>
					</wrapper-mobile-view>
					<block :height="57" />

          <template v-if="cart_step == 1">
            <ClaimingReward wrapper_class="mt-4 px-4"></ClaimingReward>
            
            <!-- MERCHANT & TICKET -->
            <div class="mt-4 px-4">
              <p class="mb-3 heading-6-1">{{$t('restaurant.your-order')}}</p>
              <div class="row no-gutters">
                <div class="col-4">
                  <div class="w-100">
                    <img :src="store.merchant.image_url" class="w-100 radius-6" @click="toggleDetail()">
                  </div>
                </div>
                <div class="col-8">
                  <div class="pl-3">
                    <p class="mb-1 body-1-4">{{ store.merchant.name }}</p>
                    <p class="mb-1 body-2-2">{{ $formatDate(store.date) }}</p>
                    <p class="mb-1 body-2-4">{{ $formatCurrency(total_price) }}</p>
                    <p class="mb-1 body-2-4 text-green cursor-pointer" @click="toggleDetail()">View Detail</p>
                  </div>
                </div>
              </div>
              <div class="w-100 border-b-semi-grey-dashed my-3"></div>
              <p class="mb-3 sub-heading-1-1">Selected Tickets</p>
              <template v-for="product_cart in store.cart">
                <productCartExperience  :data="product_cart" />
              </template>
            </div>
            <div class="w-100 border-semi-grey my-4"></div>

            <!-- PRODUCT -->
            <!-- <div class="container mb-4 pb-3 box-shadow-primary">
              <div class="px-2">
                <p class="mb-3 body-3-3 text-16 font-bold">{{$t('restaurant.your-order')}}</p>
                <template v-for="product_cart in store.cart">
                  <productCartExperience  :data="product_cart" />
                </template>
                <router-link :to="'/'+getMerchant.code+'/concierge/experience/'+store.merchant.id+'/list'">
                  <p class="mb-0 body-2-2 font-semibold text-orange underline">+ {{$t('hotel.action.add-more')}}</p>
                </router-link>
              </div>
            </div> -->

            <!-- NOTE -->
            <div class="mt-4 px-4" id="note_section">
              <p class="mb-3 heading-6-1">{{$t('hotel.concierge.add-note')}}</p>
              <textarea placeholder="Please leave a note if you have a special request" v-model="note" class="form-control p-3 body-2-2 rounded-6 mb-2" rows="2"></textarea>
            </div>
            <div class="w-100 border-semi-grey my-4"></div>

            <!-- CUSTOMER DETAIL -->
            <div class="mt-4 px-4">
              <p class="mb-0 heading-6-1">{{$t('hotel.menu.personal-data')}}</p>
              <p class="mb-3 body-2-2-1">{{$t('hotel.concierge.fitur.cart.personal-data-desc')}}</p>
              <div class="p-3 border-green rounded-6 position-relative mb-3" v-if="!isLoggedIn">
                <div class="w-100 z-index-1029 position-relative">
                  <div class="row no-gutters">
                    <div class="col-2">
                      <svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.7197 23.4622C26.0828 23.4622 30.6089 18.7115 30.6089 12.57C30.6089 6.5416 26.0494 1.95416 20.7197 1.95416C15.39 1.95416 10.8305 6.62643 10.8349 12.6146C10.8394 18.7115 15.3812 23.4622 20.7197 23.4622ZM4.40358 46.2676H36.5789C36.3024 45.675 36.1641 45.042 36.1641 44.3688V35.3786C34.8003 34.2997 33.7874 32.8695 33.1942 31.2659C29.9529 29.2092 25.7191 27.8148 20.7197 27.8148C8.00167 27.8148 0 36.4888 0 42.7956C0 44.9625 1.64828 46.2676 4.40358 46.2676Z" class="fill-primary"/>
                        <path d="M42.4595 18.5428C38.2325 18.5428 34.8879 21.9119 34.8879 26.07C34.8879 29.2144 36.74 31.9443 39.573 33.1029V44.3688C39.573 44.7026 39.7332 44.965 39.9646 45.2233L41.9566 47.2001C42.2302 47.4603 42.6615 47.4894 42.9929 47.1825L46.6416 43.5137C46.9774 43.1936 46.9642 42.7602 46.6326 42.4445L44.5138 40.2877L47.5221 37.3598C47.8133 37.0485 47.7976 36.6019 47.4819 36.2461L44.5868 33.3466C48.0446 31.8738 49.9998 29.2527 49.9998 26.07C49.9998 21.9119 46.6308 18.5428 42.4595 18.5428ZM42.4394 22.2234C43.6853 22.2234 44.7149 23.2685 44.7149 24.4987C44.7149 25.8048 43.6853 26.8342 42.4394 26.8342C41.1824 26.8342 40.1284 25.8048 40.1284 24.4987C40.1284 23.2685 41.1579 22.2234 42.4394 22.2234Z" class="fill-primary"/>
                      </svg>
                    </div>
                    <div class="col-10">
                      <p class="mb-1 body-1-4">Login or register to get many benefits</p>
                      <p class="mb-3 body-2-2">Transactions are easier and faster by filling in personal data automatically, and you can view order history easily</p>
                      <div class="no-ws">
                        <button class="g-btn g-btn-primary g-btn-md d-inline-block align-middle mr-3" @click="goToAuthPage()">Login</button>
                        <button class="g-btn g-btn-secondary g-btn-md d-inline-block align-middle" @click="goToAuthPage('Register')">Register</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.02"></div>
              </div>
              <div class="p-3 border-green rounded-6 position-relative mb-3" v-if="isReservationActive && reservation.room.id">
                <div class="w-100 z-index-1029 position-relative">
                  <div class="row no-gutters">
                    <div class="col-2 align-self-center">
                      <svg width="49" height="33" viewBox="0 0 49 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 31.248C0 32.2692 0.659284 32.9182 1.67354 32.9182H2.85386C3.85592 32.9182 4.52739 32.2692 4.52739 31.248V28.4983C4.74031 28.5587 5.40645 28.6003 5.8909 28.6003H43.1092C43.5936 28.6003 44.2597 28.5587 44.4726 28.4983V31.248C44.4726 32.2692 45.1441 32.9182 46.1463 32.9182H47.3265C48.3407 32.9182 49 32.2692 49 31.248V19.6959C49 15.9181 46.913 13.8568 43.1248 13.8568H5.87529C2.09059 13.8568 0 15.9181 0 19.6959V31.248Z" class="fill-primary"/>
                        <path d="M4.69727 10.9485H9.67143V8.29877C9.67143 6.46945 10.6823 5.47767 12.5462 5.47767H19.5981C21.4464 5.47767 22.4572 6.46945 22.4572 8.29877V10.9485H26.7492V8.29877C26.7492 6.46945 27.76 5.47767 29.7055 5.47767H36.3949C38.3402 5.47767 39.3511 6.46945 39.3511 8.29877V10.9485H44.3408V5.47614C44.3408 1.8674 42.3885 0 38.8475 0H10.1749C6.634 0 4.69727 1.8674 4.69727 5.47614V10.9485Z" class="fill-primary"/>
                      </svg>
                    </div>
                    <div class="col-10 align-self-center">
                      <p class="mb-1 body-1-4">Room reservation : {{ reservation.room.name }}</p>
                      <p class="mb-0 body-2-2">You will transact through the room</p>
                    </div>
                  </div>
                </div>
                <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.02"></div>
              </div>
              <div class="w-100 mb-3">
                <label for="form_name" class="body-3-1 mb-1 w-100">{{$t('general.your-name')}}</label>
                <input 
                  id="form_name" 
                  type="text" 
                  :placeholder="$t('hotel.concierge.fitur.cart.placeholder-name')" 
                  class="border-semi-grey rounded-6 body-2-1 w-100 mb-1"
                  :class="{'border-danger':form_validation.name != ''}"
                  style="padding: 12px 14px;"
                  v-model="customer_detail.first_name" />
                  <p v-if="form_validation.name != ''" class="mb-0 body-3-3-1 text-danger">{{form_validation.name}}</p>
              </div>
              <div class="w-100 mb-3">
                <label for="form_email" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.fitur.cart.email-address')}}</label>
                <input 
                  id="form_email" 
                  type="text" 
                  :placeholder="$t('hotel.concierge.fitur.cart.placeholder-email')" 
                  class="border-semi-grey rounded-6 body-2-1 w-100 mb-1"
                  :class="{'border-danger':form_validation.email != ''}"
                  style="padding: 12px 14px;"
                  v-model="customer_detail.email" />
                  <p v-if="form_validation.email != ''" class="mb-0 body-3-3-1 text-danger">{{form_validation.email}}</p>
              </div>
              <div class="w-100 mb-3">
                <label for="form_phone" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.form.phone-number')}}</label>
                <input 
                  id="form_phone" 
                  type="text" 
                  :placeholder="$t('hotel.concierge.fitur.cart.placeholder-phone-number')" 
                  class="border-semi-grey rounded-6 body-2-1 w-100 mb-1"
                  :class="{'border-danger':form_validation.phone_number != ''}"
                  style="padding: 12px 14px;"
                  v-model="customer_detail.phone_number" />
                <p v-if="form_validation.phone_number != ''" class="mb-0 body-3-3-1 text-danger">{{form_validation.phone_number}}</p>
              </div>
            </div>
            <div class="w-100 border-semi-grey my-4"></div>

            <!-- PAYMENT OPTION -->
            <template v-if="general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
              <div class="mt-4 px-4" :class="payment_mode_valid != '' ? 'border-danger' : ''">
                <PaymentOption @getSelectedOption="getPaymentOptionSelected"></PaymentOption>
              </div>  
              <p v-if="payment_mode_valid != ''" class="mb-0 body-3-3-1 text-danger">{{payment_mode_valid}}</p>
              <div class="w-100 border-semi-grey my-4"></div>
            </template>
          </template>
          <template v-else>
            <div class="mt-4 px-4">
              <p class="mb-0 heading-6-1">Choose payment method</p>
              <p class="mb-3 body-2-2-1">All transaction are secured and encrypted</p>
              <div class="w-100 py-4" v-if="payment_method.is_load">
                <loader></loader>
              </div>
              <template v-else>
                <div class="w-100" v-if="payment_method.error != ''">
                  <ErrorMessage :message="payment_method.error"></ErrorMessage>
                </div>
                <template v-else>
                  <template v-for="(pm,index) in payment_method.list">
                    <div class="w-100 mb-3 radius-6 p-3 cursor-pointer position-relative" :class="pm.id == payment_method.selected.id ? 'border-green' : 'border-semi-grey'" @click="payment_method.selected = pm">
                      <div class="w-100 z-index-1028">
                        <div class="row no-gutters">
                          <div class="col-1">
                            <div class="dimention-24 rounded-circle" :class="pm.id == payment_method.selected.id ? 'custom-radio-active' : 'border-semi-grey-3'">
                            </div>
                          </div>
                          <div class="col-9">
                            <div class="px-2">
                              <p class="mb-0 body-2-1" :class="{'text-green': pm.id == payment_method.selected.id}">{{pm.name}}</p>
                              <span v-if="pm.bank_name == 'DIRECT_PAYMENT' || (pm.bank_name == 'WISE' && pm.payment_method == 'BANK_TRANSFER')" class="body-3-3-2 mb-0 text-orange d-block">{{$t('general.manually-checked')}}</span>
                              <span v-else class="body-3-3-2 mb-0 text-green d-block">{{$t('general.checked-automatically')}}</span>
                              <div class="body-3-3-1 html-desc" :class="{'text-truncate-2' : pm.id != payment_method.selected.id}" v-html="pm.description"></div>
                            </div>
                          </div>
                          <div class="col-2">
                            <img :src="pm.image_url" style="width: 100%; object-fit:contain;" class="rounded-6">
                          </div>
                        </div>
                      </div>
                      <div v-if="pm.id == payment_method.selected.id" class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.04"></div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
            <div class="w-100 border-semi-grey my-4"></div>
          </template>

          <!-- PRICE -->
          <div class="mt-4 px-4">
            <p class="mb-3 heading-6-1">{{$t('hotel.concierge.price-detail')}}</p>
            <div class="p-3 border-green rounded-6 position-relative">
              <div class="w-100 z-index-1029 position-relative">
                <div class="row mb-2 pb-1">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.sub-total')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(getConciergeOrderExperienceSubTotal)}}</p>
                  </div>
                </div>
                <div class="row mb-2 pb-1">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.concierge.tax-service')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{formatCurrency(getConciergeOrderExperienceTotalTaxServices)}}</p>
                  </div>
                </div>
                <div class="row mb-2 pb-1" v-if="payment_surcharge > 0">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 font-semibold">{{$t('hotel.payment-surcharge')}}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 font-semibold">{{$formatCurrency(payment_surcharge)}}</p>
                  </div>
                </div>
                <div class="border-top">
                  <div class="row pt-2">
                    <div class="col-6">
                      <p class="mb-0 body-1-2 font-bold">{{$t('hotel.concierge.total')}}</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-1-2 font-bold">{{formatCurrency(total_price+payment_surcharge)}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.04"></div>
            </div>
          </div>

          <!-- SUBMIT AREA -->
          <div class="container px-4 pt-4 mb-3 mt-2">
            <div class="mb-4" v-if="error_push != ''">
              <ErrorMessage :message="error_push" />
            </div>
            <state-button 
              size="lg"
              variant="primary" 
              block 
              :click="submitForm">
              {{ btn_text }}
            </state-button>
          </div>
        </template>
      </template>
    </div>


    <!-- XENDIT CC FORM -->
    <popup-detail 
      direction="bottom" 
      :show="payment_in_page.show"
      wrapper_size="full"
      :no_close_backdrop="true"
      @close="togglePaymentInPage">
      <template v-slot:body>
        <div class="p-5">
          <XenditCardPayment
            v-if="payment_in_page.show"
            :tx_payment="payment_in_page.data"
            module_page="UPSELLING"
            @done="resetCart"
            @expired="togglePaymentInPage">
          </XenditCardPayment>
        </div>
      </template>
    </popup-detail>

    <!-- DETAIL MERCHANT -->
    <popup-detail 
      direction="bottom" 
      :show="show_detail"
      wrapper_size="mobile"
      @close="toggleDetail">
      <template v-slot:body>
        <div class="w-100 position-relative" style="height:200px;">
          <img :src="store.merchant.image_url" class="img-fit rounded-top-12" />
          <div class="bg-white rounded-circle position-absolute border-semi-grey cursor-pointer" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleDetail()">
            <img src="../../../../assets/img/icon/close.png" width="14" />
          </div>
        </div>
	    	<div class="p-4 bg-light-desktop">
          <p class="mb-4 sub-heading-1-2">{{ store.merchant.name }}</p>
          <!-- HIGHLIGHT -->
          <div class="w-100 bg-white rounded-6 p-3 mb-4" v-if="store.merchant.highlights != null">
            <p class="body-1-4 w-100 pb-3 mb-3 border-b-semi-grey">{{$t('merchant.highlights')}}</p>
            <p class="body-2-2" v-html="store.merchant.highlights"></p>
          </div>

          <!-- EXPERIENCE -->
          <div class="w-100 bg-white rounded-6 p-3 mb-4" v-if="store.merchant.experience != null">
            <p class="body-1-4 w-100 pb-3 mb-3 border-b-semi-grey">{{$t('merchant.what-you-will-experience')}}</p>
            <p class="body-2-2" v-html="store.merchant.experience"></p>
          </div>

          <!-- HOW TO REDEEM -->
          <div class="w-100 bg-white rounded-6 p-3 mb-4" v-if="store.merchant.how_to_redeem != null">
            <p class="body-1-4 w-100 pb-3 mb-3 border-b-semi-grey">{{$t('merchant.how-to-redeem')}}</p>
            <p class="body-2-2" v-html="store.merchant.how_to_redeem"></p>
          </div>

          <!-- TERMS AND CONDITIONS -->
          <div class="w-100 bg-white rounded-6 p-3 mb-4" v-if="store.merchant.terms_and_conditions != null">
            <p class="body-1-4 w-100 pb-3 mb-3 border-b-semi-grey">{{$t('merchant.term-condition')}}</p>
            <p class="body-2-2" v-html="store.merchant.terms_and_conditions"></p>
          </div>

          <!-- CANCELLATION POLICY -->
          <div class="w-100 bg-white rounded-6 p-3" v-if="store.merchant.cancellation_policy != null">
            <p class="body-1-4 w-100 pb-3 mb-3 border-b-semi-grey">{{$t('merchant.cancellation-policy')}}</p>
            <p class="body-2-2" v-html="store.merchant.cancellation_policy"></p>
          </div>
        </div>
      </template>
    </popup-detail>

    <warning-box 
      v-if="error_chat.show" 
      :title="$t('hotel.concierge.fitur.laundry.action-message')"
      :body="$t('hotel.concierge.fitur.laundry.error-chat')+' '+ error_chat.timer + ' ' +$t('hotel.concierge.fitur.laundry.seconds')" />
	</div>
</template>
<script>
  import moment from 'moment'
	import {mapGetters,mapMutations} from 'vuex';
	import {formatCurrency,formatDate} from '@/utils/index.js'
  import {post,get} from '@/services/index.js';
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");
  import config from '@/config/index.js';
  import productCartExperience from '@/components/hotel/concierge/general/productCartExperience'
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import PopUpBackground from '@/components/hotel/concierge/general/popUpBG';
  import WarningBox from '@/components/general/WarningBox'
  import PaymentOption from '@/components/hotel/concierge/transaction/PaymentOption'
  import XenditCardPayment from '@/components/v2/XenditCardPayment';
  import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';

	export default{
		components:{
			productCartExperience,
			BottomNavbar,
			PopUpBackground,
      WarningBox,
      PaymentOption,
      XenditCardPayment,
      ClaimingReward
		},
		metaInfo(){
      return {
        title: 'Things To Do Cart',
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    data(){
    	return{
        is_load: true,
        error: '',
        general_data: '',
    		push_loader: false,
        note: '',
        error_push: '',
        cart_result: false,
        error_chat: {
          show: false,
          timer: 0
        },
        customer_detail:{
          first_name: '',
          email: '',
          phone_number: ''
        },
        form_validation:{
          name: '',
          email: '',
          phone_number: '',
        },
        payment_mode_selected:{},
        payment_mode_valid: '',
        cart_step: 1,
        payment_method:{
          list: [],
          selected: {},
          is_load: false,
          error: ''
        },
        tx_inquiry: {},
        payment_in_page:{
          show: false,
          data: {}
        },
        show_detail:false,
        reservation: {}
    	}
    },
    mixins: [validationMixin],
    validations: {
      customer_detail:{
        first_name:{
          required
        },
        email:{
          required,
          email
        },
        phone_number:{
          required
        }
      }
    },
    computed:{
      ...mapGetters([
				'getMerchant',
				'getConciergeOrder',
				'getMetaTitleTemplate',
				'getConciergeOrderExperienceSubTotal',
				'getConciergeOrderExperienceTotalTaxServices',
        'getUpsellRef',
        'isLoggedIn',
        'getCurrentUser',
        'isReservationActive',
        'getReservationActive',
        'isMembershipRewardApplied',
        'getMembershipRewardApplied']),
    	store(){
    		return this.getConciergeOrder.experience
    	},
    	total_price(){
    		return this.getConciergeOrderExperienceSubTotal+this.getConciergeOrderExperienceTotalTaxServices
    	},
    	CartItemQty(){		
				let total = 0
        for(let data of this.getConciergeOrder.experience.cart){
          total += data.qty
        }
        return total
			},
      show_error_chat(){
        return this.error_chat.show
      },
      need_payment(){
        let general_loaded = this.general_data.id
        let default_payment_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let selected_paymnet_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode_selected.id == 'PAY_IMMEDIATELY' 

        return general_loaded && (default_payment_now || selected_paymnet_now)
      },
      btn_text(){
        let text = 'Book Now'
        if(this.need_payment && this.cart_step == 1){
          text = 'Continue to payment'
        }
        return text
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.selected.id){
					if(this.payment_method.selected.surcharge_type == 'PERCENT'){
						total = (this.total_price/100)*this.payment_method.selected.surcharge_value
					}else{
						total = this.payment_method.selected.surcharge_value
					}
				}

				return total
			},
    },
    watch:{
      show_error_chat(){
        if (this.error_chat.show) {
          let looping = setInterval(() => {
            if (this.error_chat.timer > 0) {
              this.error_chat.timer--
            }else if(this.error_chat.timer == 0){
              this.error_chat.show = false
              clearInterval(looping)
              this.resetConciergeOrder()
              this.$router.push('/'+this.getMerchant.code+'/concierge/order?reload=1')
            }
          },1000) 
        }
      }
    },
    created(){
      this.$validateActiveReward('concierge-experience')
    },
    mounted(){
      this.setActiveRoute('')
    	document.getElementById('cart').scrollIntoView({
          behavior: 'smooth'
      });
      this.loadFirstData()
    },
		methods:{
			...mapMutations(['resetConciergeOrder','setActiveRoute','setReservationActive']),
			formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
			goMerchantList(){
				this.$router.push(`/${this.getMerchant.code}/concierge/experience`)
			},
      togglePaymentInPage(){
        this.payment_in_page.show = !this.payment_in_page.show 
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
      },
      fillCustomerData(with_rsv=true){
        if(with_rsv){
          this.customer_detail = {
            first_name: this.reservation.guest_profile.name,
            email: this.reservation.guest_profile.email,
            phone_number: this.reservation.guest_profile.phone
          }
        }else{
          let name = this.$isNotEmpty(this.getCurrentUser.last_name) ? `${this.getCurrentUser.first_name} ${this.getCurrentUser.last_name}` : this.getCurrentUser.first_name
          this.customer_detail = {
            first_name: name,
            email: this.getCurrentUser.email,
            phone_number: this.getCurrentUser.phone
          }
        }
      },
      getPaymentOptionSelected(data){
        this.payment_mode_selected = data == null ? {} : data
      },
      changeCartStep(step){
        this.cart_step = step
        this.$smoothScroll('cart')
        if(this.cart_step == 2){
          this.loadPaymentList()
        }
      },
      scrollTo(id){
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth'
        });
      },

      loadFirstData(){
        this.is_load = true
        this.error = ''
        let func_exc = [this.loadGeneralSetting()]
        if(this.isReservationActive){
          func_exc.push(this.loadDetailReservation())
        }
        Promise.all(func_exc)
          .then(()=>{
            if(!this.isReservationActive && this.isLoggedIn){
              this.fillCustomerData(false)
            }
          })
          .catch(err=>this.error = err)
          .finally(()=>this.is_load = false)
      },
      loadGeneralSetting(){
        return new Promise((success,fail)=>{
          this.general_data = {}  
          get("CONCIERGE","experience/general",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.general_data = res.data
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadDetailReservation(){
				return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
                this.fillCustomerData()
							} else{
								this.setReservationActive('reset')
							}
              success()
            }else{
              fail(res.message)
            }
          })
        })
			},
      loadPaymentList(){
        this.payment_method = {
          list: [],
          selected: {},
          is_load: true,
          error: ''
        }
        get('CONCIERGE',`merchant-payment/${this.getMerchant.id}`).then(response=>{
          let res = response.data
          if(res.success){
            res.data.forEach(pm => {
              let is_payment_avlb = this.$conciergeAvlbPayment.some(x=>x.bank_name == pm.bank_name && x.payment_method.some(y=>y == pm.payment_method))
              
              if(is_payment_avlb) this.payment_method.list.push(pm)
            });
          }else{
            this.payment_method.error = res.message
          }
          this.payment_method.is_load = false
        })
			},
      validateForm(){
        this.payment_mode_valid = ''
        this.form_validation = {
          name: '',
          email: '',
          phone_number: ''
        }
        let invalid={
          name: this.$v.customer_detail.first_name.$invalid,
          email: this.$v.customer_detail.email.$invalid,
          phone_number: this.$v.customer_detail.phone_number.$invalid
        }
        if(invalid.name){
          this.form_validation.name = 'Please input your name'
        }
        if(invalid.email){
          if(!this.$v.customer_detail.email.required){
            this.form_validation.email = 'Please input your email address'
          }else if(!this.$v.customer_detail.email.email){
            this.form_validation.email = 'Incorrect email'
          }else{
            this.form_validation.email = ''
          }
        }
        if(invalid.phone_number){
          this.form_validation.phone_number = 'Please input your phone number'
        }

        if(this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && !this.payment_mode_selected.id){
          this.payment_mode_valid = 'Please select payment time'
        }
        
        if(invalid.name || invalid.email || invalid.phone_number){
          this.$smoothScroll('note_section')
        }
        
        let is_all_valid = !invalid.name && !invalid.email && !invalid.phone_number && this.payment_mode_valid == ''
        
        return is_all_valid
      },
      getApiParams(type='inquiry'){
        let params = {}
        if(type == 'inquiry'){
          let getRoomId = () => {
            return this.isReservationActive && Object.keys(this.reservation.room).length > 0 ? this.reservation.room.id : ''
          }
          
          params = {
            merchant_id: this.getMerchant.id,
            products:[],
            customer_detail: this.customer_detail,
            room_id: getRoomId(),
            merchant_pos_id: this.general_data.merchant_pos_id,
            merchant_partner_id: this.store.merchant.id,
            notes: this.note,
            region: '',
            device: this.$getDeviceType(),
            promo_code: this.getConciergeOrder.promo_code,
            campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
            guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : '',
            cta_id: this.getUpsellRef.cta_id || '',
            payment_mode: this.payment_mode_selected.id ? this.payment_mode_selected.id : this.general_data.payment_mode,
            reservation_id: this.reservation.id ? this.reservation.id : null  
          }

          if(this.isMembershipRewardApplied){
            params.membership_reward_id = this.getMembershipRewardApplied.id
          }

          for(let cart of this.getConciergeOrder.experience.cart){
            if(cart.product.is_variant){
              for(let variant of cart.variant){
                let product = {
                  id: variant.data.product_ga_pos_id,
                  qty: variant.qty,
                  service_date: moment(this.getConciergeOrder.experience.date).format("YYYY-MM-DD")+" 00:00",
                  notes: variant.notes
                }
                params.products.push(product)
              }
            }else{
              let product = {
                id: cart.product.data.product_ga_pos_id,
                qty: cart.qty,
                service_date: moment(this.getConciergeOrder.experience.date).format("YYYY-MM-DD")+" 00:00",
                notes: cart.notes
              }
              params.products.push(product)
            }
          }
        }else{
          let total_amount = Number(this.tx_inquiry.total_payment)+Number(this.payment_surcharge)
          params = {
	      		merchant_id: this.getMerchant.id,
	      		tx_order_invoice_id: this.tx_inquiry.id,
	      		amount: this.$roundPriceByCurrency(Number(total_amount.toFixed(2))),
	      		customer_detail: {
	      			name: this.customer_detail.first_name,
	      			email: this.customer_detail.email,
	      			phone_number: this.customer_detail.phone_number
	      		},
	      		payment_details: {
	      			id: this.payment_method.selected.id,
	      			payment_method: this.payment_method.selected.payment_method,
	      			bank_name: this.payment_method.selected.bank_name,
	      			payment_channel: this.payment_method.selected.payment_channel
	      		}
	      	}
        }
        return params
      },
      submitForm(){
        return new Promise((success,fail)=>{
          if(this.cart_step == 1){
            let is_form_valid = this.validateForm()
            if(is_form_valid){
              this.pushApiInquiry().then(res=>{
                if(this.need_payment){
                  this.tx_inquiry = res.data
                  this.changeCartStep(2)
                }else{
                  this.resetConciergeOrder('with_reward')
                  this.$router.push(`/${this.getMerchant.code}/concierge/trx-result/${res.data.id}`)
                }
                success()
              }).catch(err=>{
                this.error_push = err
                fail()
              })
            }else{
              fail()
            }
          }else{
            this.pushApiPayment().then((res_payment)=>{
              success()
            }).catch(err=>{
              this.error_push = err
              fail()
            })
          }
        })
      },
			pushApiInquiry(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams()
          post("CORE_HOTEL","merchant-pos/tx-inquiry",params).then(response=>{
            let res = response.data
            if(res.success){
              this.resetCart()
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      },
      pushApiPayment(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams('payment')
	      	post("CORE_HOTEL","merchant-pos/tx-payment",params).then(response=>{
            let res = response.data
            if(res.success){
              if(this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD'){
                this.payment_in_page.data = res.payment
                this.payment_in_page.show = true
              }else{
                this.$proceedPayment('CONCIERGE',this.tx_inquiry,res,this.payment_method.selected)
              }
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      },
      resetCart(){
      	this.resetConciergeOrder('with_reward')
      },
      goToAuthPage() {
        this.$openAuthModal({ view: 'login' })
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/thingstodo/MerchantCart.vue